export default function auth ({ to, next, store, nextVue }){

    if(!store.state.data.userLogin)
    {
        if( store.state.data.get.using_sso=='1' )
        {
            return nextVue({
                path: '/'+to.params.ic_url +'/login',
            });
        }
    }
   
    return next()
}